import { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'

import { CallTracking } from '../types'

type Props = {
  locationPhone?: string
  location?: string
  callTracking?: CallTracking
  locationLength: number
}

export const CitiesWithPhone: FC<Props> = ({ location, locationPhone, callTracking, locationLength }) => {
  return (
    <Container>
      {location && (
        <>
          <DealerIcon>
            <Icon name="location" size={0.75} />
          </DealerIcon>
          <Text>{location}</Text>
        </>
      )}
      {locationLength <= 1 && locationPhone && (
        <Phone className={callTracking ? callTracking.phoneWrapperClass : ''} href={`tel:${locationPhone}`}>
          {locationPhone}
        </Phone>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing[4]};
`

const Text = styled.p`
  margin: 0;
  margin-right: ${({ theme }) => theme.spacing[4]};
  ${({ theme }) => theme.textStyles.p2};
  color: ${({ theme }) => theme.palette.grey[900]};
`

const Phone = styled.a`
  margin: 0;
  margin-right: ${({ theme }) => theme.spacing[4]};
  ${({ theme }) => theme.textStyles.p1};
  color: ${({ theme }) => theme.palette.brand.primary};
  text-decoration: none;
`

const DealerIcon = styled.div`
  margin-right: 3px;
  color: ${({ theme }) => theme.palette.grey[500]};
`
